import React from 'react';
import { Provider } from 'react-redux';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { Provider as RebassThemeProvider } from 'rebass';
import store from '../store';
import history from '../history';
import Home from '../Home';
import Dashboard from '../Dashboard';

export default function App() {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <RebassThemeProvider>
          <Route exact path="/" component={Home} />
          <Route path="/dashboard" component={Dashboard} />
        </RebassThemeProvider>
      </ConnectedRouter>
    </Provider>
  );
}



// WEBPACK FOOTER //
// ./src/App/index.js